const Canvas = (props) => <canvas {...props} />;

export default Canvas;
